import {newAxios} from './index'
import { enum_subject } from '@/util/paramsConfig'
import {
  filterProp
} from '@/util'
export const Req_GetTemplateList = function () {
  return newAxios({
    url: `/i/tenant/finance/subject/all`
  })()
}

export const Req_GetTempDetail = function (data) {
  return newAxios({
    url: `/i/tenant/finance/subject/bean/tree`,
    data
  })()
}

export const Req_UpdateSubject = function (data) {
  return newAxios({
    url: `/i/tenant/finance/subject/bean/update`,
    data: filterProp(enum_subject,data)
  },'json')()
}

export const Req_GetSubjectType = function (data) {
  return newAxios({
    url: `/i/tenant/finance/subject/bean/customer/type/list`,
    data
  })
}

export const Req_GetTempTypes = function () {
  return newAxios({
    url: `/i/finance/subject/types`
  })()
}

export const Req_GetSubjectConfigTree = function (data) {
  return newAxios({
    url: `/i/admin/finance/subject/bean/tree`,
    data
  })()
}

//科目列表精简版(客户)
export const Req_GetSubjectTree = function(data) {
  return newAxios({
    url:`/i/tenant/finance/subject/bean/customer/tree/lite`,
    data
  })()
}



// WEBPACK FOOTER //
// ./src/request/subject.js